@if (tiergruppeActive$ | async) {
  @if (mainFilename$ | async; as mainFilename) {
    <tgv-angebot
      *axLazyElement="'tgv-angebot/' + mainFilename"
      [dispatcher]="globalEventDispatcher"></tgv-angebot>
  }
}
